"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function DocPass(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5V2a1 1 0 00-1-1H3a1 1 0 00-1 1v12a1 1 0 001 1h3.5a.5.5 0 010 1H3a2 2 0 01-2-2V2a2 2 0 012-2h9a2 2 0 012 2v2.5a.5.5 0 01-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6h2a.5.5 0 010 1h-2a.5.5 0 010-1zM4.5 9h2a.5.5 0 010 1h-2a.5.5 0 010-1zM4.5 3h6a.5.5 0 010 1h-6a.5.5 0 010-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5A4.5 4.5 0 1110.5 7a.5.5 0 010 1 3.5 3.5 0 103.5 3.5.5.5 0 011 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.854 7.146a.5.5 0 010 .707l-5 5a.502.502 0 01-.227.13l-.084.014h-.085a.5.5 0 01-.311-.145l-2-2a.5.5 0 01.707-.707l1.646 1.647 4.646-4.647a.5.5 0 01.707 0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(DocPass);
var _default = ForwardRef;
exports["default"] = _default;